module.exports = __webpack_public_path__ + "img/icon-certificate.056cf35f.svg";